import { Box, Button, TextInput, Select, Grid } from "@mantine/core";
import { useForm } from "@mantine/form";
import { yupResolver } from "mantine-form-yup-resolver";
import { Database } from "types/supabase";
import * as yup from "yup";
import { useUpdateUser } from "hooks/users";
import { useNavigate } from "react-router-dom";

interface UserFormProps {
  isNew?: boolean;
  user?: Database["public"]["Tables"]["users"]["Row"];
}

export const UserForm = (props: UserFormProps) => {
  const { isNew = false, user } = props;
  const navigate = useNavigate();

  const updateUser = useUpdateUser(() => navigate(-1));

  const schema = yup.object().shape({
    name: yup.string().min(2, "title should have at least 2 letters"),
  });

  const form = useForm({
    initialValues: {
      name: user?.name || "",
      email: user?.email || "",
      preferredLanguage: user?.preferred_language || "",
    },

    validate: yupResolver(schema),
  });

  const formSubmit = async (values: any) => {
    const editedUser = {
      name: values.name,
      email: values.email,
      preferred_language: values.preferredLanguage,
    };

    if (isNew) {
    } else {
      updateUser.mutate({
        uid: user!.uid,
        ...editedUser,
      });
    }
    // if (error) {
    //   form.setErrors(error);
    // } else {
    //   // router.push("/events");
    // }
  };

  return (
    <Box>
      <form onSubmit={form.onSubmit(formSubmit)}>
        <Grid>
          <Grid.Col span={6}>
            <TextInput label="Name" {...form.getInputProps("name")} />
          </Grid.Col>
          <Grid.Col span={6}></Grid.Col>
          <Grid.Col span={6}>
            <TextInput label="Email" {...form.getInputProps("email")} />
          </Grid.Col>

          <Grid.Col span={6}>
            <Select
              label="Language"
              data={["en", "pt"]}
              {...form.getInputProps("preferredLanguage")}
              w="fit-content"
            />
          </Grid.Col>
        </Grid>

        <Button mt="md" type="submit" loading={updateUser.isPending}>
          {isNew ? "Create" : "Save"}
        </Button>
      </form>
    </Box>
  );
};
